import React, { Component } from 'react';

import EmisorSuggestions from '../../../emisores/suggestions/EmisorSuggestions';
import { Button } from 'react-bootstrap';

class EmisorSelection extends Component {

  handleOnSelect = (item) => {
    const { data } = this.props;

    this.props.onFormDataChange({
      ...data,
      Emisor: {
        ...item,
      }
    });
  }

  handleOnEmisorReset = () => {
    const { data } = this.props;

    this.props.onFormDataChange({
      ...data,
      Emisor: {}
    });
  }

  render() {
    const { data, autoFocus } = this.props;

    return (
      <div>
        <EmisorSuggestions
          autoFocus={ autoFocus }
          data={ data.Emisor }
          onSelect={ this.handleOnSelect }
        />

        {/*
          TODO:

          Agregar FacAtrAdquirente si es cfdi 4.0
        */}

        { !!data.Emisor && !!data.Emisor.id && (
            <Button variant="secondary" className="mt-3" onClick={ this.handleOnEmisorReset }>
              Cambiar
            </Button>
          )
        }
      </div>
    )
  }
}

export default EmisorSelection;